import i18n from "@/i18n";

export default {
  headers: [
    {
      text: i18n.t("crudMyBookings.hDateStart"),
      value: "dateStart",
      align: "left",
      width: "14em",
    },
    {
      text: i18n.t("crudMyBookings.hDateEnd"),
      value: "dateEnd",
      align: "left",
      width: "14em",
    },
    {
      text: i18n.t("crudMyBookings.hCenter"),
      value: "center.name",
      align: "left",
      width: "14em",
    },
    {
      text: i18n.t("crudMyBookings.hEquipments"),
      value: "equipments",
      align: "left",
    },
    {
      text: i18n.t("crudMyBookings.hReason"),
      value: "reason",
      align: "left",
    },
    {
      text: i18n.t("crudMyBookings.hComplement"),
      value: "complement",
      align: "left",
    },
    {
      text: i18n.t("crudMyBookings.hActions"),
      value: "actions",
      align: "center",
      sortable: false,
      width: "8em",
    },
  ],
  locale: {
    titleNotCancelled: i18n.t("crudMyBookings.equipmentTitle"),
    titleCancelled: i18n.t("crudMyBookings.equipmentTitleCancelled"),
    search: i18n.t("crudMyBookings.search"),
  },
};
